import { Link } from 'react-router-dom';
import { Lock } from 'lucide-react';
import { Button } from './ui/button';
import { useAuth } from '../contexts/AuthContext';

export const SubscriptionRequired = () => {
  const { logout } = useAuth();
  return (
    <div className="min-h-screen flex items-center justify-center bg-background px-4" data-testid="subscription-required">
      <div className="max-w-md w-full bg-white border border-slate-200 rounded-2xl shadow-lg p-8 text-center">
        <Lock className="h-10 w-10 text-primary mx-auto mb-4" aria-hidden="true" />
        <h1 className="text-2xl font-bold font-['Manrope'] mb-2">Abonnement MON AE requis</h1>
        <p className="text-sm text-muted-foreground mb-6">
          Votre compte n'a pas d'abonnement actif. Vos données sont conservées : abonnez-vous pour accéder à vos devis, factures, dépenses et tableau de bord.
        </p>
        <div className="flex flex-col gap-3">
          <Button asChild size="lg" data-testid="subscription-required-monthly-btn">
            <Link to="/achat?plan=monthly">S'abonner — 29,99 €/mois</Link>
          </Button>
          <Button asChild size="lg" variant="outline" data-testid="subscription-required-annual-btn">
            <Link to="/achat?plan=annual">S'abonner à l'année — 299 €/an</Link>
          </Button>
          <Link to="/profil-entreprise" className="text-sm text-muted-foreground underline mt-2" data-testid="subscription-required-profile-link">Mon profil</Link>
          <button type="button" onClick={logout} className="text-sm text-muted-foreground underline" data-testid="subscription-required-logout-btn">Se déconnecter</button>
        </div>
      </div>
    </div>
  );
};
